import { FC, useState, useEffect } from "react";

import Table from "@components/Table";
import CustomModal from "@components/customModel";
import { IModal, IVersion } from "@types";
import {
  ErrorServices,
  useFetchSalaryRangeVersionsQuery,
  useUpdateSalaryRangeVersionMutation,
} from "@services";
import { getVersionsColumns } from "../config";
import { useTypedSelector } from "@hooks";

interface ISalaryRangeVersions extends IModal {
  download: (id?: number) => void;
}

const SalaryRangeVersions: FC<ISalaryRangeVersions> = ({
  isVisible,
  setIsVisible,
  download,
}) => {
  const { company } = useTypedSelector(state => state.auth.user!);
  const { id: company_id } = company!;

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [versionId, setVersionId] = useState<number | null>(null);

  const { data: versions, isLoading } = useFetchSalaryRangeVersionsQuery({
    page,
    pageSize,
    company_id,
  });

  const [updateSalaryRangeVersion] = useUpdateSalaryRangeVersionMutation();

  const { data, pagination } = versions || {};

  useEffect(() => {
    if (data?.length) {
      const activeVersion = data.find(
        (version: IVersion) => version.is_active === "TRUE"
      );

      if (activeVersion?.id) {
        setVersionId(activeVersion.id);
      }
    }
  }, [data]);

  const handleActive = async (id: number) => {
    try {
      setVersionId(id);
      await updateSalaryRangeVersion({ id, company_id }).unwrap();
    } catch (error) {
      ErrorServices(error);
    }
  };

  const versionsColumns = getVersionsColumns({
    handleActive,
    versionId,
    download,
  });

  return (
    <CustomModal
      isVisible={isVisible}
      title="Previous Versions of Salary Ranges"
      onClose={() => setIsVisible(false)}
      footer={null}
      width="w-3/4"
      height="80vh"
    >
      <Table
        isLoading={isLoading}
        data={data}
        columns={versionsColumns}
        pagination
        customStyles="m-4"
        count={pagination?.count}
        onChangePage={setPage}
        onPageSizeChange={setPageSize}
        page={page}
      />
    </CustomModal>
  );
};

export default SalaryRangeVersions;